import { render, staticRenderFns } from "./OrdonnancesHorse.vue?vue&type=template&id=664843a8&"
import script from "./OrdonnancesHorse.vue?vue&type=script&lang=js&"
export * from "./OrdonnancesHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports